module.exports = __webpack_public_path__ + "static/media/plus-rounded.be7487b7.svg";